/** Chọn dòng của bảng: hàm thuần để kiểm được, giữ thứ tự theo danh sách gốc. */
export type Sel = ReadonlySet<string>;

export function toggleOne(sel: Sel, key: string): Set<string> {
  const n = new Set(sel);
  if (n.has(key)) n.delete(key);
  else n.add(key);
  return n;
}

/** Ô "chọn tất cả": đang chọn đủ thì bỏ hết các dòng đang hiện, không thì chọn thêm hết. */
export function toggleAll(sel: Sel, keys: readonly string[]): Set<string> {
  const all = keys.length > 0 && keys.every((k) => sel.has(k));
  const n = new Set(sel);
  for (const k of keys) {
    if (all) n.delete(k);
    else n.add(k);
  }
  return n;
}

export function allState(sel: Sel, keys: readonly string[]): 'none' | 'some' | 'all' {
  const c = keys.filter((k) => sel.has(k)).length;
  return c === 0 ? 'none' : c === keys.length ? 'all' : 'some';
}
